enum dirEnum {
  Left = 'left',
  Right = 'right',
}

const isLTR = true; // TODO conditional of html direction

export const dir = isLTR ? dirEnum.Left : dirEnum.Right;

export const isOSThemeSupported = () => window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(prefers-color-scheme: light)').matches;
